const ACTIONS = {
  LINK: 'link',
  ENABLE_UPDATES: 'enable-updates',
  DISABLE_UPDATES: 'disable-updates',
  FORCE_UPDATE: 'force-update',
  ARCHIVE: 'archive',
  UNARCHIVE: 'unarchive',
  UNLINK: 'unlink'
}
ACTIONS.ALL = _.values(ACTIONS)
ACTIONS.ARCHIVABLE = [ACTIONS.ARCHIVE, ACTIONS.UNARCHIVE]
ACTIONS.LIBRARIABLE = [ACTIONS.LINK, ACTIONS.UNLINK, ACTIONS.ENABLE_UPDATES, ACTIONS.DISABLE_UPDATES, ACTIONS.FORCE_UPDATE]
Object.freeze(ACTIONS)

export { ACTIONS }
